<div class="summary-stats">
  <mat-card
    appearance="outlined"
    class="summary-card remaining-credits"
  >
    <mat-card-content>
      <div class="summary-content">
        <div class="summary-label">
          {{ "CREDITS.SUMMARY.REMAINING" | translate }}
        </div>
        <div class="credit-currencies">
          @for (credit of client?.credits ?? []; track credit.currency_iso) {
            <div class="summary-amount">
              {{ credit.remaining | currency: credit.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
            </div>
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- <mat-card class="summary-card used-credits">
  <mat-card-content>
    <div class="summary-content">
      <div class="summary-label">
        {{ "CREDITS.SUMMARY.USED" | translate }}
      </div>
      <div class="credit-currencies">
        @for (credit of client?.credits ?? []; track credit.currency_iso) {
          <div class="summary-amount">
            {{
            credit.used
            | currency
            : credit.currency_iso
            : "symbol-narrow"
            : "1.0"
            : "hu"
            }}
          </div>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card> -->
</div>
